import React from "react";
import PlatformDealsSection from "./affiliates/PlatformDealsSection";
import RecentActivityList from "../../../../components/ui/RecentActivityList";
import AdminDataTable from "../../../admin/components/AdminDataTable";
import { mockCreator } from "../../../../data/mockData";

const AffiliatesTab = ({ deals, onActivateDeal }) => {
  const activatedDeals = deals.filter((deal) => deal.isActivated);
  const affiliateTransactions = mockCreator.mockTransactions
    .filter((txn) => txn.type === "Affiliate")
    .slice(0, 5);

  const performanceColumns = [
    {
      header: "Program",
      key: "program",
      render: (row) => (
        <p className="font-medium text-slate-800">{row.brand}</p>
      ),
    },
    {
      header: "Clicks",
      key: "clicks",
      // ✨ FIX: Use optional chaining or provide a default value to prevent crash
      render: (row) => (row.clicks || 0).toLocaleString(),
    },
    {
      header: "Conversions",
      key: "conversions",
      // ✨ FIX: Use optional chaining or provide a default value to prevent crash
      render: (row) => (row.conversions || 0).toLocaleString(),
    },
    {
      header: "Total Earnings (ETB)",
      key: "earnings",
      // ✨ FIX: Use optional chaining or provide a default value to prevent crash
      render: (row) => (
        <p className="font-semibold">
          {(row.earningsETB || 0).toLocaleString()}
        </p>
      ),
    },
  ];

  return (
    <div className="space-y-8">
      {/* 1. Section to Discover and Activate New Deals */}
      <PlatformDealsSection deals={deals} onActivateDeal={onActivateDeal} />

      {/* 2. Section for Performance History of Activated Deals */}
      {activatedDeals.length > 0 && (
        <div>
          <h3 className="text-lg font-semibold text-slate-800 mb-4">
            Your Activated Deals
          </h3>
          <AdminDataTable columns={performanceColumns} data={activatedDeals} />
        </div>
      )}

      {/* 3. Section for Recent Affiliate Transactions */}
      <RecentActivityList
        title="Recent Affiliate Activity"
        transactions={affiliateTransactions}
      />
    </div>
  );
};

export default AffiliatesTab;
